import React from "react";
import Accordion from "react-bootstrap/Accordion";
import PaginationModified from "../../../data/PaginationModified";
import { CrossCircleIcon, DownloadIcon } from "../../../images/icons/icons";
import { isDev } from "../../common-data/Commons";
import {
  convertStraight,
  formatTimezoneThenStraight,
} from "../../common-data/Converts";

const BCAReportLogsMobile = ({
  tableData,
  tablePagination,
  isPage,
  setIsPage,
  pageLimit,
  setPageLimit,
  userInfoData,
  setModValues,
  loading,
}) => {
  const isAdmin = userInfoData?.account_type === "admin";
  const isTrainer = userInfoData?.account_type === "trainer";

  function getPagination() {
    try {
      const pagination = tablePagination ? tablePagination : [];
      return pagination;
    } catch (error) {
      console.log(error);
    }
  }

  return (
    <div className="all-leads-log mt30">
      {tableData?.length > 0 &&
        tableData.map((row, index) => {
          const isCompleted = row?.status === "completed";
          const isPending =
            (row?.status === "pending" && isTrainer) ||
            (row?.status === "pending" && isDev);

          return (
            <div className="log-card" key={index}>
              <div className="all-info" style={{ rowGap: "1rem" }}>
                <div className="log-card-top">
                  <div className="profile-name-number">
                    <div className="name-number">
                      <h3 className="lead-name">
                        {row?.trainer_name || "No Trainer Assigned"}
                      </h3>

                      {row?.trainer_name && (
                        <>
                          <p className="number">{row?.trainer_mobile || ""}</p>
                          {row?.trainer_email ? (
                            <span className="value email semi-bold">
                              {row?.trainer_email || ""}
                            </span>
                          ) : null}

                          <span
                            className="handover-pt-status icon"
                            style={{
                              background: !row?.trainer_status
                                ? ""
                                : row?.trainer_status === "active"
                                ? "#379C00"
                                : row?.trainer_status === "pending"
                                ? "#157EF9"
                                : "#C80000",
                              color: !row?.trainer_status ? "#000" : "#fff",
                            }}
                          >
                            {row?.trainer_status?.replace(/_/g, " ") || "-"}
                          </span>
                        </>
                      )}
                    </div>
                  </div>
                </div>

                <div className="all-followuo-info-container">
                  <Accordion>
                    <Accordion.Item eventKey="0">
                      <Accordion.Header style={{ padding: "0 10px 10px 10px" }}>
                        Show More
                      </Accordion.Header>

                      <Accordion.Body>
                        <div className="lead-multi-value-cols px20px pb20px">
                          <div className="label-value icon">
                            <span className="label">BCA Status</span>
                            <span
                              className="value"
                              style={{
                                background:
                                  isCompleted || isPending
                                    ? ""
                                    : row?.status === "completed"
                                    ? "#379C00"
                                    : row?.status === "upcoming"
                                    ? "#157EF9"
                                    : row?.status === "pending"
                                    ? "#FB9E3A"
                                    : "#C80000",
                                color: isCompleted || isPending ? "" : "#fff",
                                cursor: isPending ? "pointer" : "not-allowed",
                                padding: "5px",
                              }}
                            >
                              {isCompleted ? (
                                <>
                                  {row?.bca_report ? (
                                    <a
                                      className=""
                                      rel="noreferrer"
                                      target="_blank"
                                      href={row.bca_report}
                                    >
                                      <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="16"
                                        height="16"
                                        fill="currentColor"
                                        className="bi bi-box-arrow-up-right"
                                        viewBox="0 0 16 16"
                                        style={{
                                          cursor: "pointer",
                                          opacity: 1,
                                        }}
                                      >
                                        <path
                                          fillRule="evenodd"
                                          d="M8.636 3.5a.5.5 0 0 0-.5-.5H1.5A1.5 1.5 0 0 0 0 4.5v10A1.5 1.5 0 0 0 1.5 16h10a1.5 1.5 0 0 0 1.5-1.5V7.864a.5.5 0 0 0-1 0V14.5a.5.5 0 0 1-.5.5h-10a.5.5 0 0 1-.5-.5v-10a.5.5 0 0 1 .5-.5h6.636a.5.5 0 0 0 .5-.5"
                                        />
                                        <path
                                          fillRule="evenodd"
                                          d="M16 .5a.5.5 0 0 0-.5-.5h-5a.5.5 0 0 0 0 1h3.793L6.146 9.146a.5.5 0 1 0 .708.708L15 1.707V5.5a.5.5 0 0 0 1 0z"
                                        />
                                      </svg>
                                    </a>
                                  ) : (
                                    <CrossCircleIcon />
                                  )}
                                </>
                              ) : (
                                row?.status?.replace(/_/g, " ") || "NA"
                              )}
                            </span>
                          </div>

                          <div className="label-value">
                            <span className="label">Scheduled Date</span>
                            <span className="value">
                              {row?.scheduled_date
                                ? convertStraight(row.scheduled_date)
                                : "-"}
                            </span>
                          </div>

                          <div className="label-value">
                            <span className="label">Completed On</span>
                            <span className="value">
                              {row?.completed_on
                                ? convertStraight(row.completed_on)
                                : "-"}
                            </span>
                          </div>
                        </div>

                        <div className="all-btns lead-btn-axceed">
                          <div className="lead-log-box">
                            <button
                              className="lead-log view-lead"
                              disabled={!isPending}
                              style={{
                                textTransform: "capitalize",
                                minWidth: "100px",
                                opacity: isPending ? "1" : "0.5",
                                cursor: isPending ? "pointer" : "not-allowed",
                              }}
                              onClick={() =>
                                isPending &&
                                setModValues((prevs) => ({
                                  ...prevs,
                                  isModOpen: true,
                                  rowData: row,
                                  modName: "upload_bca",
                                }))
                              }
                            >
                              <DownloadIcon />
                            </button>

                            <span className="btn-label">BCA Upload</span>
                          </div>
                        </div>
                      </Accordion.Body>
                    </Accordion.Item>
                  </Accordion>
                </div>
              </div>
            </div>
          );
        })}

      <div className="lead-logs-card-pagination">
        <PaginationModified
          isPage={isPage}
          onChangePage={setIsPage}
          pagination={getPagination()}
          pageLimit={pageLimit}
          setPageLimit={setPageLimit}
        />
      </div>
    </div>
  );
};

export default BCAReportLogsMobile;
